/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Shashwat Kashyap",
  title: "Hi all, I'm Shashwat",
  subTitle: emoji(
    "Full-stack Developer 🧑‍💻 | Innovator 🚀 | Writer 🖊️| Passionate about building impactful tech across education, health, and enterprise."  
  ),
  resumeLink:
    "https://docs.google.com/document/d/1jmjX_E73HwV_cv24MnDpys4rUKA57roE/edit?usp=sharing&ouid=117647405367905602308&rtpof=true&sd=true", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Shashwat-k-9114",
  linkedin: "https://www.linkedin.com/in/shashwat-kashyap-b417aa155?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  gmail: "kashyapshashwat77@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I Do",
  subTitle: "AI • CLOUD • FULL-STACK ENGINEER BUILDING INTELLIGENT, SCALABLE & IMPACTFUL SYSTEMS",

  skills: [
    emoji("⚡ Build intelligent systems using Machine Learning, predictive analytics, and multi-output models."),
    emoji("⚡ Develop scalable full-stack applications using MERN, Python, Flask, and FastAPI."),
    emoji("⚡ Create automation pipelines, REST APIs, dashboards, and cloud-native services."),
    emoji("⚡ Engineer AI-driven tools including anomaly detectors, recommendation engines, and prompt automation systems."),
    emoji("⚡ Design secure data models, optimize workflows, and integrate CRM solutions with Salesforce & Agentforce."),
  ],

  softwareSkills: [
    // Web & Full Stack
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Express.js",
      fontAwesomeClassname: "fas fa-server"
    },

    // Backend & APIs
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Flask / FastAPI",
      fontAwesomeClassname: "fas fa-code"
    },

    // ML / AI
    {
      skillName: "Machine Learning",
      fontAwesomeClassname: "fas fa-brain"
    },
    {
      skillName: "Data Science",
      fontAwesomeClassname: "fas fa-chart-line"
    },

    // Databases
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "MySQL",
      fontAwesomeClassname: "fas fa-database"
    },

    // Cloud & Tools
    {
      skillName: "Google Cloud",
      fontAwesomeClassname: "fas fa-cloud"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "GitHub",
      fontAwesomeClassname: "fab fa-github"
    },

    // Salesforce Ecosystem
    {
      skillName: "Salesforce / CRM",
      fontAwesomeClassname: "fas fa-bolt"
    },
    {
      skillName: "Agentforce",
      fontAwesomeClassname: "fas fa-robot"
    },

    // Other Skills
    {
      skillName: "REST APIs",
      fontAwesomeClassname: "fas fa-random"
    },
    {
      skillName: "Automation",
      fontAwesomeClassname: "fas fa-sync"
    }
  ],

  display: true
};


// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Birla Institute of Technology, Mesra",
      logo: require("./assets/images/bitmesra.png"),
      subHeader: "Bachelors in Computer Applications (BCA)",
      duration: "October 2021 - May 2024",
      descBullets: [
        "CGPA: 7.76",
      ]
    },
    {
      schoolName: "Birla Institute of Technology, Mesra",
      logo: require("./assets/images/bitmesra.png"),
      subHeader: "Masters in Computer Applications (MCA)",
      duration: "August 2024 - May 2026",
      descBullets: ["CGPA: 7.71"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend (React)", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend (Node.js, Express, SQL, php)", //Insert stack or technology you have experience in
      progressPercentage: "80%"
    },
    {
      Stack: "Programming (Python, Java)", //Insert stack or technology you have experience in
      progressPercentage: "60%"
    },
    {
      Stack: "Research",
      progressPercentage: "80%"
    },
    {
      Stack: "Design",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Salesforce Developer Intern",
      company: "AA2IT India Pvt. Ltd.",
      companylogo: require("./assets/images/aa2it.png"),
      date: "Dec 2025 – Present",
      desc: "Working under the Salesforce Delivery Head to develop and configure CRM solutions, automation workflows, custom data models, and AI-powered features using Salesforce, Agentforce, and Prompt Builder."
    },
    {
      role: "Software Intern",
      company: "Prustaz Technologies Pvt. Ltd.",
      companylogo: require("./assets/images/prustaz.png"),
      date: "Dec 2025 – Present",
      desc: "Contributing to innovation-driven software projects, supporting engineering tasks, collaborating in development cycles, and assisting in full-stack and backend implementations."
    },
    {
      role: "Full Stack Developer Intern",
      company: "Pinaqtech",
      companylogo: require("./assets/images/pinaqtech.jpeg"),
      date: "May 2025 – Aug 2025",
      desc: "Developed and deployed the official company website using MERN stack. Improved SEO ranking by 40%, reduced bounce rate, integrated advanced security features, and enhanced cross-platform user experience."
    },
    {
      role: "Software Engineering Intern",
      company: "Oohr Innovations",
      companylogo: require("./assets/images/Oohr.png"),
      date: "May 2025 – Jul 2025",
      desc: "Built a custom ERP for educational institutions, automating operational workflows and reducing manual work by 60%. Led QA testing, resolved 20+ critical issues, and increased platform reliability."
    },
    {
      role: "MIS Intern",
      company: "Furnish Me Architects",
      companylogo: require("./assets/images/furnishme.png"),
      date: "May 2025 – Jul 2025",
      desc: "Developed a secure centralized intranet for analytics and reporting. Improved data accessibility and reporting speed by 40% through optimized workflow architecture."
    },
    {
      role: "Senior Developer Intern – Government Project",
      company: "DST Menstrual Hygiene App",
      companylogo: require("./assets/images/dst.png"),
      date: "Jul 2023 – Apr 2024",
      desc: "Engineered scalable features for a public-health application serving 5,000+ users. Collaborated with healthcare professionals to transform medical requirements into technically robust modules."
    },
    {
      role: "Python Developer Intern",
      company: "CodSoft",
      companylogo: require("./assets/images/codsoft.png"),
      date: "Sep 2023 – Oct 2023",
      desc: "Developed five automation tools for sentiment analysis, data processing, workflow automation, and scheduled tasks using Python."
    },
    {
      role: "Operations Intern",
      company: "ICIEM International Conference – BIT Mesra",
      companylogo: require("./assets/images/bitmesra.png"),
      date: "May 2023 – Jun 2023",
      desc: "Managed logistics for 100+ international delegates. Streamlined documentation workflows, reducing turnaround time by 40%."
    },
    {
      role: "Marketing Intern",
      company: "BIT Mesra Admission Campaign",
      companylogo: require("./assets/images/bitmesra.png"),
      date: "May 2023 – Jul 2023",
      desc: "Designed and executed A/B tested marketing creatives that increased applicant engagement and conversions by 20%."
    },
    {
      role: "Senior Intern",
      company: "BIT Noida",
      companylogo: require("./assets/images/bitmesra.png"),
      date: "May 2024 – Jul 2024",
      desc: "Led data-driven digital campaigns; increased admission inquiries by 30% through analytics-based optimization and targeted outreach."
    }
  ]
};


/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "AI SYSTEMS • FULL-STACK PLATFORMS • CLOUD & AUTOMATION",
  
  projects: [
    // ----------------- AI & ML PROJECTS -----------------
    {
      image: require("./assets/images/f1.png"),
      projectName: "F1 Oracle",
      projectDesc:
        "ML-powered Formula 1 race prediction engine using Random Forest and historical race data. Features real-time simulations, performance insights, and interactive visual dashboards.",
      footerLink: [{ name: "Live Demo", url: "https://f1-oracle.streamlit.app/" }]
    },
    {
      image: require("./assets/images/evdt.png"),
      projectName: "EV Anomaly Detector",
      projectDesc:
        "Real-time anomaly detection system for EV batteries using predictive ML algorithms. Identifies voltage and temperature anomalies with interactive performance monitoring dashboards.",
      footerLink: []
    },
    {
      image: require("./assets/images/ClarifAI.png"),
      projectName: "ClarifAI",
      projectDesc:
        "AI-powered prompt engineering tool that converts natural language instructions into structured prompts, JSON workflows, and markdown-ready documentation. Built with Python, Streamlit & OpenAI API.",
      footerLink: [{ name: "Live Demo", url: "https://clarifaio.streamlit.app/" }]
    },
    {
      image: require("./assets/images/pgai.png"),
      projectName: "PlantGuard AI",
      projectDesc:
        "Image-based plant disease detection system using ML classification models. Provides treatment recommendations with a clean and responsive Flask interface.",
      footerLink: []
    },
    {
      image: require("./assets/images/CM.png"),
      projectName: "CineMatch AI",
      projectDesc:
        "Hybrid movie recommendation platform combining TMDB API data with dataset-based filtering. Includes trending movies, intelligent search, and a personalized Watchlist.",
      footerLink: []
    },
    {
      image: require("./assets/images/LC.png"),
      projectName: "LifeCompass",
      projectDesc:
        "Multi-output ML engine generating personalized life decision scores with interpretable outputs. Includes REST API, model explanation layers, and responsive UI.",
      footerLink: []
    },
    {
      image: require("./assets/images/cpp.png"),
      projectName: "Car Price Predictor",
      projectDesc:
        "ML-based used-car price prediction app built with Python & Flask. Includes form input validation, batch CSV predictions, charts, and clean UI.",
      footerLink: []
    },
    {
      image: require("./assets/images/si.png"),
      projectName: "Stock Price Predictor",
      projectDesc:
        "Time-series forecasting tool using ARIMA/LSTM models to predict stock movements. Includes real-time charts, a watchlist, and API-driven predictions.",
      footerLink: []
    },
    {
      image: require("./assets/images/wai.png"),
      projectName: "Weather Forecasting App",
      projectDesc:
        "Weather analytics dashboard integrating API weather data with ML-based short-term predictions. Includes city search, error handling, and responsive visualizations.",
      footerLink: []
    },

    // ----------------- FULL STACK PROJECTS -----------------
    {
      image: require("./assets/images/skyvault.png"),
      projectName: "SkyVault",
      projectDesc:
        "Encrypted file-sharing platform with role-based access control, analytics logging, and secure cloud storage. Built using MERN.",
      footerLink: [{ name: "Live Demo", url: "https://skyvaulty.onrender.com/" }]
    },
    {
      image: require("./assets/images/gradlink.png"),
      projectName: "GradLink",
      projectDesc:
        "Alumni networking portal connecting 5,000+ BIT Mesra alumni and students. Features authentication, intelligent search, chat, and profile discovery.",
      footerLink: [{ name: "GitHub", url: "https://github.com/bionicop/Alumni-Connect/tree/master" }]
    },
    {
      image: require("./assets/images/tt.png"),
      projectName: "Timetable Generator — BIT Noida",
      projectDesc:
        "Constraints-based timetable generator built with MERN stack. Supports clash-free scheduling, admin controls, and exportable academic timetables.",
      footerLink: []
    },
    {
      image: require("./assets/images/iciem.png"),
      projectName: "ICIEM 2026 Conference Portal",
      projectDesc:
        "Full-stack conference portal enabling automated paper submission, reviewer workflows, participant acknowledgement, and event management.",
      footerLink: []
    },
    {
      image: require("./assets/images/ted.png"),
      projectName: "TEDx BIT Mesra Website",
      projectDesc:
        "Official event website with automated registration, payment validation, and Google Sheets+Drive integration using Apps Script.",
      footerLink: []
    },

    // ----------------- AUTOMATION / PYTHON TOOLS -----------------
    {
      image: require("./assets/images/alfred.png"),
      projectName: "Alfred — Voice Assistant",
      projectDesc:
        "Python-based voice-controlled automation assistant achieving ~90% accuracy. Handles app commands, task execution, search automation, and workflow shortcuts.",
      footerLink: []
    }
  ],

  display: true
};



// Achievement Section
// Include certificates, talks etc

export const achievementSection = {
  title: emoji("Achievements & Publications 🏆"),
  subtitle: "Recognitions, writing, and creative contributions across tech and literature.",

  achievementsCards: [
    {
      title: "Scholarships",
      subtitle: "Awarded the GP Birla Foundation Scholarship and Dr. Usha Aggarwal Trust Scholarship for academic excellence and social impact.",
      image: require("./assets/images/scholarship.png"),
      imageAlt: "Scholarship Medal Icon",
      footerLink: []
    },
    {
      title: "Publications",
      subtitle: `"The Potential Impact of Quantum Computing" – Bits & Bytes\n"The Age of the Forgotten Mind" – BIT Newsletter\n"A Bittersweet Farewell" – WhyNot Australia`,
      image: require("./assets/images/publication.png"),
      imageAlt: "Writing Icon",
      footerLink: []
    },
    {
      title: "Creative Works",
subtitle: `• Poems published in:
  - Be Limitless (World Book Fair 2025)
  - Chromatic Currents V3
  - Golden Realms V4

• Notable works:
  - Alone (BIT FUSION)
  - Symphony of Despair (WhyNot Australia)
  - Echoes in the Abyss (WhyNot Australia)
  - The Greyness of Man (WhyNot Australia)`,
      image: require("./assets/images/poem.png"),
      imageAlt: "Poetry Icon",
      footerLink: []
    }
  ],
  display: true
};



// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91 9818383499",
  email_address: "kashyapshashwat77@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};




const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  //achievementSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};

